import PropTypes from 'prop-types';

export const dietaryTagPropTypes = PropTypes.shape({
  id: PropTypes.number,
  dietaryTag: PropTypes.string, // The name of the tag
  default: PropTypes.number, // ?
});

export const dietaryTagsPropTypes = PropTypes.shape({
  data: PropTypes.arrayOf(dietaryTagPropTypes),
  error: PropTypes.string,
  pending: PropTypes.bool,
  success: PropTypes.bool,
});
